// extracted by mini-css-extract-plugin
export default {"placeholder":"Lu7o6","difference":"tsy8K","quiz":"HD7Sp","connectionQuiz":"WiLyZ","icon":"_9i1wv","text":"bZ8MK"};